// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ik","header":"il","subHeader":"im","button":"in","actionLinks":"io","actionLink":"ip","actionText":"iq"};